import { useState } from 'react'
import useSWR from 'swr'
import internalApiQueryWrapper from '../../network/internalApiQueryWrapper'
import Row from '../HomePage/Row'
import UpNextStory from './UpNextStory'
import style from '../../styles/components/story/related'

const RelatedStories = ({ story }) => {
  const [pageScrolled, setPageScrolled] = useState(false)
  const { data, error } = useSWR(
    {
      /* Fetch related stories (simply stories under the same category for now) */
      url: '/api/related',
      args: {
        categories: story.categories.map((category) => category.id).join(','),
        slug: story?.slug
      }
    },
    internalApiQueryWrapper
  )

  if (error || !data) {
    return null
  }

  const showUpnext = () => {
    const getPercentage = () => {
      const doc = document.documentElement
      const percent = ((doc.scrollTop + window.innerHeight) / doc.scrollHeight) * 100
      setPageScrolled(percent > 60)
    }

    window.onscroll = () => {
      getPercentage()
    }
  }

  return (
    <>
      <div className='related'>
        <div className='related-title'>Related</div>
        <Row section={data?.slice(1, 4)} layout='related-stories' />
      </div>
      <UpNextStory story={data?.[0]} pageScrolled={pageScrolled} showUpnext={showUpnext} />
      <style jsx>{style}</style>
    </>
  )
}

export default RelatedStories
